import { render } from "./DimensionsSection.vue?vue&type=template&id=4bd7535a&scoped=true"
import script from "./DimensionsSection.vue?vue&type=script&lang=js"
export * from "./DimensionsSection.vue?vue&type=script&lang=js"

import "./DimensionsSection.vue?vue&type=style&index=0&id=4bd7535a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd7535a"]])

export default __exports__